import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector, useDispatch } from 'react-redux';
import { toggleModal, openDetails, closeDetails } from 'reducers/ui';
import BaseDetails from 'containers/Base/BaseDetails';
import staticText from 'static/text_display.json';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { PAGE_URLS } from 'utils/constants/';
import {
  siteDataGridActions,
  siteSelectors,
  sitesNS,
} from 'containers/Pages/Locations/Sites';

const BaseSiteDetailPanel = ({
  id,
  cancel,
  editable,
  toggleEditMode,
  toggleModal,
  operationComponent,
  loading,
}) => {
  //----- Actions------------------------------///
  const dispatch = useDispatch();

  const dispatchFetchSiteDetails = useCallback(
    id => dispatch(siteDataGridActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchClearSiteDetails = useCallback(
    () => dispatch(siteDataGridActions.setGridRowDetails({ details: {} })),
    [dispatch],
  );
  const dispatchRemoveSiteOnMapId = useCallback(
    () => dispatch(siteDataGridActions.setSelectedRowID(null)),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(
    url => {
      dispatch(openDetails(url));
    },
    [dispatch],
  );
  const dispatchCloseDetails = useCallback(
    url => {
      dispatch(closeDetails(url));
    },
    [dispatch],
  );
  //-------Selectors-------------------------------//
  const siteDetails = useSelector(state =>
    siteSelectors.getSiteDetailsTransformed(state),
  );

  useEffect(() => {
    if (id) {
      dispatchFetchSiteDetails(id);
      dispatchOpenDetails(PAGE_URLS.SITES.link);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onEdit = () => {
    toggleEditMode();
    toggleModal(sitesNS);
  };

  const onCancel = () => {
    cancel();
    dispatchClearSiteDetails();
    dispatchRemoveSiteOnMapId();
    dispatchCloseDetails(PAGE_URLS.SITES.link);
  };
  return (
    <BaseDetails
      editable={editable}
      loading={loading}
      header={staticText.managerial_view.site.details}
      details={siteDetails}
      onEdit={onEdit}
      operationComponent={operationComponent}
      cancel={onCancel}
      editHoverText={
        siteDetails && Object.keys(siteDetails).length > 0
          ? translatedKeyValueText(
              'edit_value_title',
              siteDetails.generalInfo.name.value,
            )
          : staticText.managerial_view.site.edit_default
      }
    />
  );
};

const mapDispatchToProps = dispatch => ({
  toggleModal: ns => dispatch(toggleModal(ns)),
});

BaseSiteDetailPanel.propTypes = {
  id: PropTypes.string.isRequired,
  cancel: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  siteDetails: PropTypes.object,
  fetchSiteDetails: PropTypes.func,
  toggleEditMode: PropTypes.func,
  toggleModal: PropTypes.func,
  clearSiteDetails: PropTypes.func,
  operationComponent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.object,
  ]),
  loading: PropTypes.bool,
};

export default connect(
  null,
  mapDispatchToProps,
)(React.memo(BaseSiteDetailPanel));
